import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { connect, type ConnectedProps } from "react-redux";
import { get } from "lodash";
import { FiEye } from "react-icons/fi";
import { getEmployerWalletDetails } from "store/selectors/employer";
import type { RootState } from "types/state";

const mapStateToProps = (state: RootState) => {
  const walletDetails = getEmployerWalletDetails(state);

  const employerWalletAccountNumber = get(walletDetails, "accountNumber", "");

  const employerWalletRoutingNumber = get(walletDetails, "routingNumber", "");
  return {
    employerWalletAccountNumber,
    employerWalletRoutingNumber,
  };
};

const connector = connect(mapStateToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux;

interface State {
  showAccountNumber: boolean;
}

class EmployerWalletCard extends React.Component<Props, State> {
  state: State = {
    showAccountNumber: false,
  };

  render() {
    if (!this.props.employerWalletAccountNumber) {
      return null;
    }
    return (
      <Card>
        <Card.Title>
          <p className="page-header">Icon Employer Account</p>
          <p className="subtext">
            This is your dedicated Icon employer account. If you need to
            configure allow-lists or special rules for your linked accounts,
            provide these numbers to your bank. For detailed steps, see our
            <a
              className="icon-link"
              href="https://support.iconsavingsplan.com/en/articles/11403709-how-to-whitelist-icon-in-your-bank-account"
              target="_blank"
              rel="noopener noreferrer"
            >
              guide on whitelisting Icon with your bank.
            </a>
          </p>
        </Card.Title>
        <Card.Body>
          <Row>
            <Col md={6}>
              <Card>
                <Card.Body>
                  <Row>
                    <Col xs={4} className="bank-box-1">
                      <p className="bank-name">Account Number</p>
                    </Col>
                    <Col xs={6} className="bank-box">
                      <p className="bank-name">
                        {this.state.showAccountNumber
                          ? this.props.employerWalletAccountNumber
                          : "****" +
                            this.props.employerWalletAccountNumber.slice(-4)}
                        <FiEye
                          style={{ marginLeft: "10px", cursor: "pointer" }}
                          onClick={() =>
                            this.setState((prev) => ({
                              showAccountNumber: !prev.showAccountNumber,
                            }))
                          }
                        />
                      </p>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={4} className="bank-box-1">
                      <p className="bank-name">Routing Number</p>
                    </Col>
                    <Col xs={6} className="bank-box">
                      <p className="bank-name">
                        {this.props.employerWalletRoutingNumber}
                      </p>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={4} className="bank-box-1">
                      <p className="bank-name">Icon Company ID</p>
                    </Col>
                    <Col xs={6} className="bank-box">
                      <p className="bank-name">9384137089</p>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  }
}

export default connector(EmployerWalletCard);
